export default __webpack_public_path__ + "static/media/avatar_indian_boy8.f1d02a83.mp3";